import { navigateHook } from "../../../../../hooks/use-navigate.js";

export default function ReportContent({ data, tableColumns }) {
    const navigate = navigateHook();

    const address = (item) => (
        <>
            {item.dispatch_factplace}
            {item.dispatch_factplace && <br />}
            {[item.dispatch_factstreet, item.dispatch_factnumber].filter(Boolean).join(", ")}
            {item.dispatch_factneighborhood &&
            (item.dispatch_factstreet || item.dispatch_factplace) ? " - " : ""}
            {item.dispatch_factneighborhood}
            {item.dispatch_sectors ? ` (${item.dispatch_sectors})` : ""}
        </>
    );
    const columns = [
        {
            id: "attendance",
            className: "w-[11%]",
            render: (item) => (
                <>
                    <a onClick={() => navigate(`/reports/attendance_info?id=${item.attendance_id}`, true,)} className="print:text-black! report-link">
                        {item.attendance_protocol ?? ""}
                    </a>
                    <br />
                    {item.attendance_start ?? ""}
                </>
            ),
        },
        {
            id: "dispatch",
            className: "w-[11%]",
            render: (item) => (
                <>
                    <a onClick={() => navigate(`/despacho/dispatch/form/${item.dispatch_id}`, true)} className="print:text-black! report-link">
                        {item.dispatch_numbercheckbook ?? "Sem talão"}
                    </a>
                    <br />
                    {item.dispatch_start ?? ""}
                </>
            ),
        },
        {
            id: "nature",
            className: "w-[10%]",
            render: (item) => item.dispatch_nature ?? "",
        },
        { id: "address", className: "w-[16%]", render: address },
        {
            id: "garrison",
            className: "w-[16%]",
            render: (item) => item.garrison_name ?? "",
        },
        {
            id: "attendanceTime",
            className: "w-[9%]",
            render: (item) => item.attendance_time ?? "",
            average: "mediaAttendance",
        },
        {
            id: "arrivalTime",
            className: "w-[9%]",
            render: (item) => item.arrival_time ?? "",
            average: "mediaArrival",
        },
        {
            id: "mileage",
            className: "w-[10%]",
            render: (item) =>
                item.arrivalmileage != null && item.goingmileage != null ? item.arrivalmileage - item.goingmileage : "",
            average: "mediaKm",
        },
        {
            id: "duration",
            className: "w-[9%]",
            render: (item) => item.dispatch_duration ?? "",
            average: "mediaDispatchDuration",
        },
    ];

    const visibleColumns = columns.filter(
        (column) => tableColumns?.[column.id]?.visible !== false,
    );

    const exportColumns = [
        {id: "attendanceProtocol", visibility: "attendance", label: "Protocolo", render: (item) => item.attendance_protocol ?? ""},
        {id: "attendanceStart", visibility: "attendance", label: "D/H Inicial atendimento", render: (item) => item.attendance_start ?? ""},
        {id: "dispatchNumber", visibility: "dispatch", label: "Talão", render: (item) => item.dispatch_numbercheckbook ?? ""},
        {id: "dispatchStart", visibility: "dispatch", label: "D/H Inicial despacho", render: (item) => item.dispatch_start ?? ""},
        {id: "nature", visibility: "nature", label: "Natureza", render: (item) => item.dispatch_nature ?? ""},
        {id: "place", visibility: "address", label: "Local pré-cadastrado", render: (item) => item.dispatch_factplace ?? ""},
        {id: "street", visibility: "address", label: "Endereço", render: (item) => item.dispatch_factstreet ?? ""},
        {id: "neighborhood", visibility: "address", label: "Bairro", render: (item) => item.dispatch_factneighborhood ?? ""},
        {id: "sector", visibility: "address", label: "Setor", render: (item) => item.dispatch_sectors ?? ""},
        {id: "garrison", visibility: "garrison", label: "Guarnição", render: (item) => item.garrison_name ?? ""},
        {id: "attendanceTime", visibility: "attendanceTime", label: "Tempo até início do despacho", render: (item) => item.attendance_time ?? "", average: "mediaAttendance"},
        {id: "arrivalTime", visibility: "arrivalTime", label: "Tempo entre despacho e chegada no local", render: (item) => item.arrival_time ?? "", average: "mediaArrival"},
        {id: "mileage", visibility: "mileage", label: "KM percorrido entre partida e chegada", render: (item) => item.arrivalmileage != null && item.goingmileage != null ? item.arrivalmileage - item.goingmileage : "", average: "mediaKm"},
        {id: "duration", visibility: "duration", label: "Duração do despacho", render: (item) => item.dispatch_duration ?? "", average: "mediaDispatchDuration"},
    ];

    const visibleExportColumns = exportColumns.filter(
        (column) => tableColumns?.[column.visibility]?.visible !== false,
    );
    const getRowKey = (item, index) => `${item.dispatch_id ?? item.attendance_id ?? "row"}-${index}`;

    return (
        <>
            {visibleColumns.length ? (
                <table id="dispatch-arrival-data" className="table report-table" sheet-name="Tempo de chegada">
                    <thead className="thead-background">
                        <tr className="bg-[#f6f6f6] text-left">
                            {visibleColumns.map((column) => (
                                <th key={column.id} className={column.className}>
                                    {tableColumns[column.id].label}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody className="bg-white">
                        {data.result.map((item, index) => (
                            <tr key={getRowKey(item, index)} className="table-break-word">
                                {visibleColumns.map((column) => (
                                    <td key={column.id}>{column.render(item)}</td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                    <tfoot>
                        <tr className="bg-[#f6f6f6] text-left">
                            {visibleColumns.map((column, index) => (
                                <th key={column.id}>
                                    {index === 0 ? "MÉDIA" : column.average ? (data.media?.[column.average] ?? "") : ""}
                                </th>
                            ))}
                        </tr>
                    </tfoot>
                </table>
            ) : (
                <div id="noDataMessage" className="alert alert-info p-2 h6 text-center">
                    Todas as colunas foram ocultadas.
                </div>
            )}

            <table id="dispatch-arrival-export-data" className="export-data hidden" sheet-name="Tempo de chegada">
                <thead>
                    <tr>
                        {visibleExportColumns.map((column) => (
                            <th key={column.id}>{column.label}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {data.result.map((item, index) => (
                        <tr key={`export-${getRowKey(item, index)}`}>
                            {visibleExportColumns.map((column) => (
                                <td key={column.id}>{column.render(item)}</td>
                            ))}
                        </tr>
                    ))}
                </tbody>
                <tfoot>
                    <tr>
                        {visibleExportColumns.map((column, index) => (
                            <th key={column.id}>
                                {index === 0 ? "MÉDIA" : column.average ? (data.media?.[column.average] ?? "") : ""}
                            </th>
                        ))}
                    </tr>
                </tfoot>
            </table>

            <div id="chart-tables"/>
        </>
    );
}